export function pipelineItemIdentity(pipeline) {
  const item = typeof pipeline === 'string' ? { pipeline_name: pipeline } : (pipeline || {});
  return item.pipeline_id || item.id || item.pipeline_name || '';
}

export function pipelineMatchesSearch(pipeline, query) {
  const item = typeof pipeline === 'string' ? { pipeline_name: pipeline } : (pipeline || {});
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return true;
  const name = String(item.pipeline_name || '').toLowerCase();
  const owner = String(item.owner_email || '').toLowerCase();
  return name.includes(needle) || owner.includes(needle);
}

export function filterPipelines(pipelines, query) {
  return (pipelines || []).filter((pipeline) => pipelineMatchesSearch(pipeline, query));
}

export function selectionAfterSearch(pipelines, selected, query) {
  if (!selected) return null;
  const selectedId = pipelineItemIdentity(selected);
  const stillVisible = filterPipelines(pipelines, query).some(
    (pipeline) => pipelineItemIdentity(pipeline) === selectedId
  );
  return stillVisible ? selected : null;
}
